module.exports = __webpack_public_path__ + "static/media/success(20).53b980f2.png";